module.exports = __webpack_public_path__ + "static/media/garlic-ladingpage-1.f4f85c74.jpg";